import _ from "lodash";
import appConfig from "../appconfig";
import cryptoJS from "crypto-js";
import { store } from "../store";
import { getProductPrice } from "./tenantSpecific/tid6/utils";
import ProductSelection from "../domains2/orders/ProductSelection";
import * as mutationTypes from "../store/mutation-types";
import {formatPriceZero} from "../domains2/libraries/Utils";
const tenantConfig = appConfig.tenantConfig;
const { Formats: timeBoxFormats, timebox: timeBox } = appConfig.timeBoxImpl;
import LoggerProvider from "../providers/LoggerProvider";
import {isNoThanksProduct} from "../helper/ProductSelectionHelper";
import OrderHelperObject from "../domains2/orders/OrderHelperObject";
import { checkIfStringIsDate } from "../helper/PriceRulesHelper";
import { App as NativeApp } from "@capacitor/app";
import { FCM } from "@capacitor-community/fcm";
import { CUSTOMER_TYPES } from "../domains2/constants/customerTypes";
import ProductProvider from "../providers/ProductProvider";

export const isAppActive = () => {
	return new Promise((resolve) => {
		if (!appConfig.mobile.isMobileApp()) resolve(true);
		const interval = setInterval(async () => {
			const { isActive } = await NativeApp.getState();
			if (isActive) {
				clearInterval(interval);
				resolve();
			}
		}, 100);
	});
};

export const checkIsCustomAsapTime = function (closingTime, asapWaitingTime, TimeBoxHelper) {
	if(!closingTime || !TimeBoxHelper) {
		return false;
	}
	const hourAndMinute = closingTime.split(":");
	if(hourAndMinute.length < 2) {
		return false;
	}
	const now = TimeBoxHelper
		.nowInTimeZone()
		.exec();
	const lastPickupDateTime = TimeBoxHelper.nowInTimeZone()
		.set({
			hour: hourAndMinute[0],
			minute: hourAndMinute[1],
			millisecond: 0
		})
		.exec();
	const timeDifference = lastPickupDateTime.diff(now).toMillis();
	return timeDifference > 0 && timeDifference / 1000 / 60 <= asapWaitingTime.minutes;
};

export const shouldApplyCustomAsapTime = function(getters, asapWaitingTime) {
	const pickupRules = getters.cachedPickupRules;
	const TimeBoxHelper = getters.ShopTimeBoxHelper;

	const shop = getters.globalSelectedShop;

	if (!shop || appConfig.getBusinessModelId() === appConfig.businessModelsEnum.bm2.id) {
		return false;
	}

	const latestTime = OrderHelperObject.getLatestPickupTime({
		boxDate: timeBox.now(),
		products: getters.cartProducts || [],
		tenantData: tenantConfig,
		pickupDateTimeRules: pickupRules,
		shopData: shop,
		includePastTimes: false,
		ignoreOffset: true,
		pickupTimeZone: shop.shopTimeZone,
		useShopOpeningHoursByWeekday: getters.featureToggles.useShopOpeningHours
	});
	return checkIsCustomAsapTime(latestTime, asapWaitingTime, TimeBoxHelper);
};

export const isValidHhMm = (value) => {
	return /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(value);
};

export const calculatePercentage = function(value, percentage) {
	percentage = percentage ? percentage : 0;
	return (value * percentage) / 100;
};

export const formatCurrency = function(value, vat) {
	vat = vat ? vat : 0;

	if ((value % 1 !== 0) || (calculatePercentage(value, vat) % 1 !== 0)) {
		return (value + calculatePercentage(value, vat)).toFixed(2).replace(/\./g, ",");
	} else {
		return (value + calculatePercentage(value, vat))+",00";
	}
};


const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// used to retry promises
// Example:
//  const testFn = (a: number) => {
//	  const x = Math.trunc(Math.random() * 1000);
//	  console.log(x)
//	  return x % 9 === 0 ? Promise.resolve("good") : Promise.reject(1);
//  }
export const retry = (fn, options = {maxRetry: 3, currentRetry: 0, sleepLen: 100}) => (...ar) => {

	const { maxRetry, currentRetry, sleepLen } = options;
	return fn(...ar)
		.then(res => {
			return res;
		})
		.catch(e => {
			if (currentRetry < maxRetry) {
				return sleep(sleepLen).then(() => {
					return retry(fn, {...options, currentRetry: currentRetry + 1})(...ar);
				});
			} else {
				throw e;
			}
		});
};

export const range = (startDate, counter, numberOfDays) => {
	if(counter === numberOfDays) {
		return [startDate];
	}
	return [startDate, ...range(new Date(new Date(startDate).setDate(startDate.getDate() + 1)), counter + 1, numberOfDays)];
};

export const formatTelephone = (phone) => {
	return phone ? phone.trim().replace(/(.{2})/g, "$1 ").slice(0, -1) : "";
};

export const createValidationRules = function(app) {
	return {
		required: (value) => !!value || app.$t("libraries.utils.required"),
		userName: (value) => {
			const userNameRegex = app.$store.getters.tenantSettings.userNameRegex;
			const pattern = new RegExp(userNameRegex);
			return pattern.test(value) || app.$t("libraries.utils.invalidUserName");
		},
		email: (value) => {
			const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return pattern.test(value) || app.$t("libraries.utils.invalidEmail");
		},
		repeatEmailForGuestsSignup: (value) => {
			return (app._data.userEmailForm.value === value) || app.$t("libraries.utils.invalidRepeatEmail2");
		},
		repeatEmailForVerification: (value) => {
			const email = app.$store.getters.getUserData.email;
			return (email === value) || app.$t("libraries.utils.invalidRepeatEmail");
		},
		userDoesntExists: () => {
			return (!app._data.registrationFlowWarning) || app.$t("libraries.utils.userDontExist");
		},
		phone: (value) => {
			const pattern = /^(((\+|00)\d{1,3})|(\((\+|00)\d{1,3})\))?[\s-]?(\d{2,}[\s-]?){3,}\d{2}$/;
			return pattern.test(value) || app.$t("libraries.utils.invalidPhone");
		}
	};
};

export const copyObject = function(source) {
	return JSON.parse(JSON.stringify(source));
};

export const getQueryString = params => Object.keys(params).map(key => {
	return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
}).join("&");

export const getQueryParamValue = param => {
	if ("URLSearchParams" in window) {
		const url = window.location.href;
		const urlObj = new URL(url);
		const params = new URLSearchParams(urlObj.search);
		return params.get(param);
	} else {
		// Fallback for older browsers
		const regex = new RegExp("[?&]" + param + "=([^&#]*)", "i");
		const result = regex.exec(window.location.search);
		return result ? decodeURIComponent(result[1]) : null;
	}
};

export const isValidJSON = function(jsonString) {
	try {
		JSON.parse(jsonString);

		return true;
	} catch (e) {
		return false;
	}
};

export const secureStringify = function(obj) {
	try {
		return JSON.stringify(obj);
	} catch (err) {
		// We probably get a circular reference error
		const result2 = {};
		// Stringify only first level of objects to avoid circular json
		Object.keys(obj).forEach(key => {
			result2[key] = "" + obj[key];
		});
	}
};
export const isObjectOrArray = function(result) {
	const resultStr = secureStringify(result);
	const isObjOrArray = resultStr && (resultStr[0] === "{" || resultStr[0] === "[");
	return isObjOrArray;
};

/**
 * Create a simple string dump of an object.
 * */
export const simpleDump = function(object) {
	return "{ " + Object.keys(object).map(key => key + ": " + object[key]).join(", ") + " }";
};

const FILLERJPG = "filler.jpg";
export const imageRoot = (type) => {
	const isGlobalTemplate = type === "static" && tenantConfig.useGlobalTemplateImagePath;
	if (isGlobalTemplate) {
		const gtRootPath = `${store.getters.imageCDNRoot}/${type}/${appConfig.globalTemplateName}`;
		return `${gtRootPath}/images`;
	} else {
		return `${store.getters.imageCDNRoot}/${type}/${tenantConfig.tenantIdPathName}/images`;
	}
};

const imageBmRoot = (type) => {
	return `${store.getters.imageCDNRoot}/${type}/${tenantConfig.businessModelId}/images`;
};

const imageRootIdRoot = (type) => {
	return `${store.getters.imageCDNRoot}/${type}/tid${store.getters.rootTenantId}/images`;
};

const imageRootIdPaths = type => {
	return {
		"123T144": imageRootIdRoot(type) + "/123T144/",
		"41T48": imageRootIdRoot(type) + "/41T48/",
		"kiosk": imageRootIdRoot(type) + "/KIOSK/",
		"8T7": imageRootIdRoot(type) + "/8T7/",
		"1T1": imageRootIdRoot(type) + "/1T1/",
		"1T1/115": imageRootIdRoot(type) + "/1T1/115/",
		"1T1/150": imageRootIdRoot(type) + "/1T1/150/",
		"1T1/349": imageRootIdRoot(type) + "/1T1/349/",
		"1T1/365": imageRootIdRoot(type) + "/1T1/365/",
		"1T1/400": imageRootIdRoot(type) + "/1T1/400/",
		"1T1/600": imageRootIdRoot(type) + "/1T1/600/",
		"1T1/288": imageRootIdRoot(type) + "/1T1/288",
		"85T72/353": imageRootIdRoot(type) + "/85T72/353/",
		"85T72/500": imageRootIdRoot(type) + "/85T72/500/",
		"85T72/288": imageRootIdRoot(type) + "/85T72/288/",
		"8T5": imageRootIdRoot(type) + "/8T5/",
		"85T72": imageRootIdRoot(type) + "/85T72/",
		"6T1": imageRootIdRoot(type) + "/6T1/",
		"6T1_small": imageRootIdRoot(type) + "/6T1_small/",
		"5T2": imageRootIdRoot(type) + "/5T2/",
		"5T2_small": imageRootIdRoot(type) + "/5T2_small/",
		"misc": imageRootIdRoot(type) + "/misc/",
		"cards": imageRootIdRoot(type) + "/cards/",
		"icons": imageRootIdRoot(type) + "/icons/"
	};
};

const imageBmPaths = type => {
	return {
		"123T144": imageBmRoot(type) + "/123T144/",
		"41T48": imageBmRoot(type) + "/41T48/",
		"kiosk": imageBmRoot(type) + "/KIOSK/",
		"8T7": imageBmRoot(type) + "/8T7/",
		"1T1": imageBmRoot(type) + "/1T1/",
		"8T5": imageBmRoot(type) + "/8T5/",
		"85T72": imageBmRoot(type) + "/85T72/",
		"6T1": imageBmRoot(type) + "/6T1/",
		"6T1_small": imageBmRoot(type) + "/6T1_small/",
		"5T2": imageBmRoot(type) + "/5T2/",
		"5T2_small": imageBmRoot(type) + "/5T2_small/",
		"misc": imageBmRoot(type) + "/misc/",
		"cards": imageBmRoot(type) + "/cards/",
		"icons": imageBmRoot(type) + "/icons/"
	};
};

const imagePaths = type => {
	return {
		"123T144": imageRoot(type) + "/123T144/",
		"41T48": imageRoot(type) + "/41T48/",
		"kiosk": imageRoot(type) + "/KIOSK/",
		"8T7": imageRoot(type) + "/8T7/",
		"1T1": imageRoot(type) + "/1T1/",
		"8T5": imageRoot(type) + "/8T5/",
		"85T72": imageRoot(type) + "/85T72/",
		"6T1": imageRoot(type) + "/6T1/",
		"6T1_small": imageRoot(type) + "/6T1_small/",
		"5T2": imageRoot(type) + "/5T2/",
		"5T2_small": imageRoot(type) + "/5T2_small/",
		"misc": imageRoot(type) + "/misc/",
		"cards": imageRoot(type) + "/cards/",
		"icons": imageRoot(type) + "/icons/"
	};
};

/**
 * Makes it possible to set a meta tag in the head programmatically
 * @param metaName
 * @param value
 */
export const setMetaAttribute = function(metaName, value) {
	const metaTags = document.getElementsByTagName("meta");
	if (metaTags && metaTags.length) {
		Array.forEach(metaTags, tag => {
			const name = tag.getAttribute("name");
			if (name && name.toLowerCase() === metaName) {
				tag.parentElement.removeChild(tag);
			}
		});
	}
	const newMeta = document.createElement("meta");
	newMeta.setAttribute("name", metaName);
	newMeta.setAttribute("content", value);
	document.head.appendChild(newMeta);
};

/**
 * Makes it possible to set a link tag in the head programmatically
 * @param metaName
 * @param value
 */
export const setLinkCanonicalAttribute = function(linkHref) {
	removeAllLinksCanonicalAttribute();

	const linkTags = document.getElementsByTagName("link");
	if (linkTags && linkTags.length) {
		Array.forEach(linkTags, tag => {
			const href = tag.getAttribute("href");
			const rel = tag.getAttribute("rel");
			if (href && href.toLowerCase() === linkHref && rel && rel.toLowerCase() === "canonical") {
				tag.parentElement.removeChild(tag);
			}
		});
	}
	const newLink = document.createElement("link");
	newLink.setAttribute("rel", "canonical");
	newLink.setAttribute("href", linkHref);
	document.head.appendChild(newLink);
};

export const removeAllLinksCanonicalAttribute = function() {
	const linkTags = document.querySelectorAll("link[rel=\"canonical\"]");
	linkTags.forEach(tag => {
		tag.parentElement.removeChild(tag);
	});
};

export const load404Page = function() {
	const baseUrl = appConfig.mobile.isMobileApp() ? appConfig.getBaseUrl() : window.location.origin;
	const lastChar = baseUrl.substr(-1);
	const formattedBaseUrl = lastChar !== "/" ? `${baseUrl}/` : baseUrl;
	setMetaAttribute("robots", "noindex");
	const newMeta = document.createElement("meta");
	newMeta.setAttribute("http-equiv", "refresh");
	newMeta.setAttribute("content", `0 url=${formattedBaseUrl}404.html`);
	document.head.appendChild(newMeta);
};

/**
 * Implement image loading using ordinary references under static data
 * @returns {*}
 */
export const imageLoaderNew = function({
	folderName,
	imageLink,
	object,
	type = "static",
	allowOriginalFormat = false,
	width,
	height
}) {
	if (typeof imageLink !== "string" || !imageLink) {
		console.log(`Image ${imageLink} not found ` + (object ? ` for object: ${object.id}, name "${object.name}"` : "")); // eslint-disable-line no-console
		console.log(new Error(folderName)); // eslint-disable-line no-console
		imageLink = FILLERJPG;
	}
	const replaceJpg = function(pngFile) {
		if(imageLink.includes(".webp") && appConfig.isBM2()) {
			return pngFile;
		}
		const index = pngFile.lastIndexOf(".");
		return pngFile.substring(0, index) + ".jpg";
	};

	const req = folderName ? imagePaths(type)[folderName] : imageRoot(type) + "/";

	const uri = encodeURI(allowOriginalFormat ? req + imageLink : req + replaceJpg(imageLink));

	const queryString = {};

	if (typeof width === "number" || typeof width === "number") {
		const getNumber = num => num ? num : 0;
		queryString.d = `${getNumber(width)}x${getNumber(height)}`;
	}

	if (Object.keys(queryString).length > 0) {
		return uri + "?" + Object.keys(queryString).map(key => {
			return `${key}=${queryString[key]}`;
		}).join("&");
	} else {
		return uri;
	}
};

export const addQueryString = function(url, data = {}) {
	if (Object.keys(data).length > 0) {
		return url + "?" + Object.keys(data).map(key => {
			return `${key}=${data[key]}`;
		}).join("&");
	} else {
		return url;
	}
};

export const getImageDomSize = ({ imageDom, sizeMultiplier = 1 }) => {
	const getNumber = num => Math.ceil(num ? num : 0);

	const { width, height } = imageDom.getBoundingClientRect();

	return {
		width: getNumber(width) * sizeMultiplier,
		height: getNumber(height) * sizeMultiplier
	};
};

/**
 * Implement image loading using ordinary references under static data
 * @deprecated - please use imageLoaderNew
 * @returns {*}
 */
export const imageLoader = function(folderName, imageLink, object, type = "static", allowOriginalFormat = false, IsRootTenantId = false) {
	if (typeof imageLink !== "string" || !imageLink) {
		console.log(`Image ${imageLink} not found ` + (object ? ` for object: ${object.id}, name "${object.name}"` : "")); // eslint-disable-line no-console
		console.log(new Error(folderName)); // eslint-disable-line no-console
		imageLink = FILLERJPG;
	}
	const replaceJpg = function(pngFile) {
		const index = pngFile.lastIndexOf(".");
		return pngFile.substring(0, index) + ".jpg";
	};

	const req = folderName ? IsRootTenantId ? imageRootIdPaths(type)[folderName] : imagePaths(type)[folderName] : IsRootTenantId ? imageRootIdRoot(type) : imageRoot(type) + "/";

	const uri = encodeURI(allowOriginalFormat ? req + imageLink : req + replaceJpg(imageLink));

	return uri;
};

export const getMiscImageUrl = function(imageName) {
	if (appConfig.isBM100()) {
		return encodeURI(imageBmPaths("static")["misc"] + imageName);
	}
	return encodeURI(imagePaths("static")["misc"] + imageName);
};

export const getIconsImageUrl = function(imageName) {
	if (appConfig.isBM100()) {
		return encodeURI(imageBmPaths("static")["icons"] + imageName.replace("images/icons/", ""));
	}
	return encodeURI(imagePaths("static")["icons"] + imageName.replace("images/icons/", ""));
};

export const getImageFolder = ({ bmId, imgUrl, bmFolderMap = {} }) => {
	const imageParts = imgUrl.split("/");
	if (imageParts.length === 2) {
		// currently type (dynamic or static) is irrelevant for this function
		// because it only needs folder names, so it's hardcoded to be dynamic
		const isFolderInUrl = Object.keys(imagePaths("dynamic")).filter(val => {
			return val === imageParts[0];
		}).length > 0;

		if (isFolderInUrl) {
			return "";
		} else {
			console.log(new Error(imageParts[0])); // eslint-disable-line no-console
		}
	} else if (imageParts.length > 2) {
		console.log(new Error(imgUrl)); // eslint-disable-line no-console
	}
	return bmFolderMap[bmId];
};

export const validateValue = function(value, rules) {
	rules = rules ? rules : [];
	return rules.reduce((carry, rule) => {
		return carry && rule(value) === true;
	}, true);
};

export const validateForm = function(form) {
	return _.reduce(form, (carry, item) => {
		return carry && validateValue(item.value, item.rules);
	}, true);
};

export const splitCamelCase = function(string) {
	return string
		? string.split(/(?=[A-Z])/)
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(" ")
		: "";
};

export const isValidUuid = (value) => {
	const expression =
		/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
	const regex = new RegExp(expression);
	return typeof value === "string" && value.match(regex);
};

export const setPageTitle = function(route,productCatalog) {
	if(route && route.path && !route.path.includes("admin")) {
		if(route.path === "/") {
			return document.title = "Home";
		}
		else{
			const routeSplit = route.path.split("/");
			if(routeSplit.length > 3 && route.path.includes("configuration") && !route.query.editProductId) {
				const product = productCatalog.getProduct(routeSplit[3], true);
				return document.title = product.name;
			}
			if(route.path.includes("category") && !route.query.editProductId) {
				const category = getCategoryById(routeSplit[2],productCatalog);
				if(category) {
					return document.title = category.name;
				}
			}
			if(route.query.editProductId) {
				const product = productCatalog.getProduct(route.query.editProductId, true);
				return document.title = product.name;
			}
			if(route.path  !== "/") {
				return document.title = splitCamelCase(route.name);
			}
		}
	}
};

// This is a quick fix which can probably be improved using this library: http://kazupon.github.io/vue-i18n/en/pluralization.html
export const translateUnit = function(unit, count) {
	if (count === 1) {
		return unit;
	} else {
		switch (unit) {
		case "kuvert":
			return "kuverter";
		case "stk":
			return "stk";
		case "menu":
			return "menu";
		default:
			return unit;
		}

	}
};

/**
 * Returns proper document title
 */
export const getDocumentTitle = function(title) {
	const mytitle = (title ? title + " " : "") + tenantConfig.tenantName + (tenantConfig.tenantId !== 3 ? " Mad ud af huset" : " ud af huset");
	if (!appConfig.isProductionEnvironment() && typeof appConfig.loadedEnvironment() === "string") {
		if (appConfig.isBM100()) {
			return appConfig.envPrefix() === "p" ? mytitle : appConfig.envPrefix() + "-" + mytitle;
		}
		return appConfig.envPrefix() + "-" + mytitle;
	} else {
		return mytitle;
	}
};

/**
 * Returns a Date a number of days from now.
 */
export const getDaysFromNow = function(days) {
	const today = timeBox.now();
	return new Date(today.year().exec(), today.month().exec(), today.day().exec() + days);
};


/**
 * Returns a date formated to be shown on the format:
 * 23-01-2023
 * @param dateStr
 * @returns {*}
 */
export const formatDate = (date) => {
	return checkIfStringIsDate(date) ? timeBox.fromISO(date).format(timeBoxFormats.DD_MM_YYYY).exec() : "";
};

/**
 * Returns a date formated to be shown on the format:
 * Mandag d. 23. oktober
 * @param vueComp
 * @param dateStr
 * @returns {*}
 */
export const formatDateFriendly = function(vueComp, dateStr) {
	const date = new Date(dateStr);
	const day = date.getDay() !== 0 ? date.getDay() : 7;
	const month = date.getMonth() + 1;
	return vueComp.$t("libraries.utils.pickupDateFormatted", {
		dayName: _.upperFirst(vueComp.$t(`common.days.day${day}`)),
		day: date.getDate(),
		monthName: vueComp.$t(`common.months.month${month}`)
	});
};

/**
 * Returns a date formated to be shown on the format:
 * Man. 23 okt
 * @param vueComp
 * @param date
 * @returns {*}
 */
export const formatDateFriendlyShort = function(vueComp, date) {
	const day = date.getDay() !== 0 ? date.getDay() : 7;
	const month = date.getMonth() + 1;
	return vueComp.$t("libraries.utils.pickupDateFormattedShort", {
		dayName: _.upperFirst(vueComp.$t(`common.days.day${day}`)).slice(0, 3),
		day: date.getDate(),
		monthName: vueComp.$t(`common.months.month${month}`).slice(0, 3)
	});
};

/**
 * Returns a date formated to be shown on the format:
 * Man. 23 okt
 * @param vueComp
 * @param date
 * @returns {*}
 */
export const formatDateTimeFriendlyShort = function(vueComp, date) {
	const day = date.getDay() !== 0 ? date.getDay() : 7;
	const month = date.getMonth() + 1;
	return vueComp.$t("libraries.utils.pickupDateTimeFormattedShort", {
		dayName: _.upperFirst(vueComp.$t(`common.days.day${day}`)).slice(0, 3),
		day: date.getDate(),
		monthName: vueComp.$t(`common.months.month${month}`).slice(0, 3),
		hour: timeBox.fromJsObject(date).format("HH:mm").exec()
	});
};

export const toIsoString = (date) => {
	const tzo = -date.getTimezoneOffset(),
		dif = tzo >= 0 ? "+" : "-",
		pad = function(num) {
			return (num < 10 ? "0" : "") + num;
		},
		padMillis = num => (num < 10 ? "00" : (num < 100 ? "0" : "")) + num;

	return date.getFullYear() +
      "-" + pad(date.getMonth() + 1) +
      "-" + pad(date.getDate()) +
      "T" + pad(date.getHours()) +
      ":" + pad(date.getMinutes()) +
      ":" + pad(date.getSeconds()) +
			"." + padMillis(date.getMilliseconds()) +
      dif + pad(Math.floor(Math.abs(tzo) / 60)) +
      ":" + pad(Math.abs(tzo) % 60);
};

/***
 * Handles a keypress event and rejects anything but numbers, tabs, enter etc.
 * @param e
 * @returns {boolean}
 */
export const validateNumberInputEvent = function(e) {
	const allowedKeys = {
		"Delete": true,
		"Backspace": true,
		"ArrowLeft": true,
		"ArrowRight": true,
		"Tab": true,
		"Enter": true,
		"ArrowUp": true,
		"ArrowDown": true
	};
	const pattern = /([\d+\-()\s])/;
	if (pattern.test(e.key) || allowedKeys[e.key]) {
		return true;
	} else {
		e.preventDefault();
		return false;
	}
};

/***
 * Handles a keypress event and rejects anything but time format inputs (HH:MM, H:MM, 0H:MM etc.)
 * @param e
 * @returns {boolean}
 */
export const validateTimeInputEvent = function(e) {
	const allowedKeys = {
		"Delete": true,
		"Backspace": true,
		"ArrowLeft": true,
		"ArrowRight": true,
		"Tab": true,
		"Enter": true,
		"ArrowUp": true,
		"ArrowDown": true
	};
	const pattern = /([\d]|[:])/;
	// const pattern = /(((1[0-9]?)|(0?[1-9])|(2[0-3]?))[:][0-5][0-9]?)/;
	if (pattern.test(e.key) || allowedKeys[e.key]) {
		return true;
	} else {
		e.preventDefault();
		return false;
	}
};


export const formatTime = function(dateTimeStr) {
	return timeBox.fromISO(dateTimeStr).format("H:mm").exec();
};

export const showCustomersData = function(string) {
	return string !== "" ? string : "N/A";
};

/**
 * Used to generate nice guids for unittest
 * @param n
 * @returns {string}
 */
export const uid = function(n) {
	const zeros = "00000000-0000-0000-0000-000000000000";
	const nstr = n + "";
	return zeros.substring(0, zeros.length - nstr.length) + nstr;
};

export const md5HashEncode = function(string) {
	if (!string) return "";
	return cryptoJS.MD5(string).toString();
};

export const hexToRGB = function(hex, alpha = 1) {
	const parseString = (hex.startsWith("#")) ? hex.slice(1, 7) : hex;
	if (parseString.length !== 6) {
		return null;
	}
	const r = parseInt(parseString.slice(0, 2), 16);
	const g = parseInt(parseString.slice(2, 4), 16);
	const b = parseInt(parseString.slice(4, 6), 16);
	if (isNaN(r) || isNaN(g) || isNaN(b)) {
		return null;
	}
	return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const formRedirect = function({ url, method = "POST", data = {} }) {
	const form = document.createElement("form");
	document.body.appendChild(form);
	form.method = method;
	form.action = url;

	Object.keys(data).forEach(key => {
		const input = document.createElement("input");
		input.type = "hidden";
		input.name = key;
		input.value = data[key];
		form.appendChild(input);
	});

	form.submit();
};

export const getStaticPath = function() {
	const staticPrefixFolder = tenantConfig.useGlobalTemplateImagePath ? appConfig.globalTemplateName : `tid${appConfig.tenantId}`;

	const path = `static/${staticPrefixFolder}/`;

	return appConfig.mobile.isMobileApp() ? path : `/${path}`;
};

export const getAwsStaticPath = function() {
	const staticPrefixFolder = tenantConfig.useGlobalTemplateImagePath ? appConfig.globalTemplateName : appConfig.isBM100() ? `${tenantConfig.businessModelId}` : `tid${appConfig.tenantId}`;
	const path = `${store.getters.imageCDNRoot}/static/${staticPrefixFolder}/`;
	return path;
};

export const forEachAsync = async function(array, callback) {
	for (let index = 0; index < array.length; index++) {
		await callback(array[index], index, array);
	}
};

const computeFolderName = (size) => {
	const channel = appConfig.channelAlias();
	switch (channel) {
	case "kiosk":
		return "kiosk";
	default:
		return size;
	}
};

export const mainProductImage = function(product, options = {}) {
	const { width, height } = options;
	const size = (product.UIHint && product.UIHint.fullHeightImage ? "8T7" : "8T5");
	const index = product.options.imageIndexForS1 !== undefined ? product.options.imageIndexForS1 : 0;
	const img = product.imageLinks[index];
	const folderName = img.includes(size) ? "" : computeFolderName(size);
	return imageLoaderNew({
		folderName,
		imageLink: img,
		object: product,
		type: "dynamic",
		width,
		height
	});
};

export const partialString = function(string, limit = 10) {
	if (typeof string === "string" && string.length > limit) {
		return string.substring(0, limit) + "...";
	} else {
		return string;
	}
};

export const isPassedPickupTime = function(pickupDate, pickupTime, timeZone) {
	// checks if pickup date and time is today or in past
	const now = timeBox.now();
	const pickupDateTime = timeBox
		.fromDateTimeString(pickupDate, pickupTime, timeZone)
		.set({
			hour: now.hour().exec(),
			minute: now.minute().exec()
		});

	return now.gt(pickupDateTime).exec();
};

export const setConsents = function(consents) {
	window.dataLayer = window.dataLayer || [];
	function gtag(){ window.dataLayer.push(arguments); }
	if(!consents) {
		// Set default consent to 'denied' as a placeholder
		gtag("consent", "default", {
			"ad_storage": "denied",
			"ad_user_data": "denied",
			"ad_personalization": "denied",
			"analytics_storage": "denied"
		});
	} else {
		const marketing = consents["marketing"];
		const statistical = consents["statistical"];
		gtag("consent", "update", {
			"ad_storage": marketing ? "granted" : "denied",
			"ad_user_data":  marketing ? "granted" : "denied",
			"ad_personalization":  marketing ? "granted" : "denied",
			"analytics_storage":  statistical ? "granted" : "denied"
		});
	}
};

export const getProductCategory = function (categories, item) {
	return categories.find((category) => {
		return category && category.elements[0]
			? category.elements[0].props.products.includes(item.product.id)
			: undefined;
	});
};

export const getPrice = function (item) {
	if(item.productPrice) {
		return item.productPrice.discountPrice ? item.productPrice.discountPrice : item.productPrice.basePrice;
	}
	return item.product.price;
};

export const getIdAndNameFromCategory = function (category) {
	if(category) {
		return {
			id: category.id,
			name: category.name
		};
	}
	return undefined;
};

export const sendFbPixel = function(event, value, contentIds) {
	return appConfig.fbPixel("track", event, {
		currency: tenantConfig.currency,
		value,
		content_ids: contentIds,
		content_type: "product"
	});
};

export const findOrCreateProductSelection = function(id, productCatalog, component) {
	if (component.$store.getters.cartProducts) {
		const productSelections = component.$store.getters.selections.filter(p => {
			return p.productId === id;
		});

		const psOptions = {
			expiration: {
				tenantSettings: component.$store.getters.tenantSettings.productSelectionExpiration,
				tenantConfig: tenantConfig.productSelectionExpiration
			}
		};
		if (productSelections) {
			return copyObject(productSelections);
		} else {
			return [ProductSelection.createFromProduct(productCatalog.getProduct(id, true), psOptions)];
		}
	}
};
/**
 * takes objType === "GridBlockElement" element and transforms it to item
 * which is product with additional helper functions and properties
 * @param {Array<Product>} products which is actually element.items
 */
export const transformProductsToItems = function(products, productCatalog, component, deliveryChoice) {
	const self = this;

	const generalProducts = products.map(product => {
		const productSelections = findOrCreateProductSelection(product.id, productCatalog, component);

		return {
			product,
			productPrice: getProductPrice(product, productCatalog),
			quantity: productSelections.reduce((carry, selection) => carry + selection.quantity, 0),
			productSelections,
			cartQuantityDialogShown: false,
			timeoutHandle: window.setTimeout(() => {}, 3000),
			isProductEnabled: (() => {
				// check if product is disabled
				if (!product.isActive) {
					return false;
				}

				// check if one of its single subproducts is disabled
				const singleSubProducts = product.groups
					.filter(g => g.appearance === "single")
					.map(group => productCatalog.getProduct(group.options.defaultSelected, true));
				if (singleSubProducts.some(supProduct => !supProduct.isActive)) {
					return false;
				}
				if (Array.isArray(product.assortmentRules) && product.assortmentRules.length && self.globalSelectedShop) {
					const forbiddenShop = product.assortmentRules.find(rule => rule.shopId === self.globalSelectedShop.id);
					return forbiddenShop === undefined;
				}

				return true;
			})(),
			hasGroupsOrConfigurations: (() => {
				if (product.departmentId === 2) {
					const singleSubProducts = product.groups
						.filter(g => g.appearance === "single")
						.map(group => productCatalog.getProduct(group.options.defaultSelected, true));
					return singleSubProducts.some(supProduct => supProduct.groups.length > 0 || supProduct.configurations.length > 0);
				} else {
					return product.groups.length > 0 || product.configurations.length > 0;
				}
			})()
		};
	});
	const fileteredProducts = generalProducts
		.filter(product => {
			if (!product.product.isActive) {
				return false;
			}
			if (!product.isProductEnabled) {
				return false;
			}
			const options = product.product.options;
			if (options.deliveryMethodIndex) {
				if (!options.deliveryMethodIndex.includes(deliveryChoice)) {
					return false;
				}
			}
			if (!isProductAvailableForChannel(product.product)) {
				return false;
			}
			return true;
		});
	return fileteredProducts;
};
export const refreshProducts = function(category, productCatalog, component) {

	if (category.elements) {
		const productIds = _.flattenDeep([...category.elements.map(element => element.props).map(prop => prop.products)]);
		const generalProducts = productIds.map(id => {
			const productSelections = findOrCreateProductSelection(id, productCatalog, component);

			const product = productCatalog.getProduct(id, true);

			return {
				product,
				productPrice: getProductPrice(product, productCatalog),
				quantity: productSelections.reduce((carry, selection) => carry + selection.quantity, 0),
				productSelections,
				cartQuantityDialogShown: false,
				timeoutHandle: window.setTimeout(() => {}, 3000),
				isProductEnabled: (() => {
					// check if product is disabled
					if (!product.isActive) {
						return false;
					}

					// check if one of its single subproducts is disabled
					const singleSubProducts = product.groups
						.filter(g => g.appearance === "single")
						.map(group => productCatalog.getProduct(group.options.defaultSelected, true));

					return !singleSubProducts.some(supProduct => !supProduct.isActive);


				})(),
				hasGroupsOrConfigurations: (() => {
					if (product.departmentId === 2) {
						const singleSubProducts = product.groups
							.filter(g => g.appearance === "single")
							.map(group => productCatalog.getProduct(group.options.defaultSelected, true));
						return singleSubProducts.some(supProduct => supProduct.groups.length > 0 || supProduct.configurations.length > 0);
					} else {
						return product.groups.length > 0 || product.configurations.length > 0;
					}
				})()
			};
		});
		return Object.values(generalProducts.filter(product => product.product.isActive));
	}
};
const getFilteredProductGroupSteps = (productGroupsWithoutBaseProduct, product) => {
	// generate config steps based on the existing product groups for the "extras" template
	const stepsBasedOnRealGroups = productGroupsWithoutBaseProduct.map(() => CONFIGURATION_STATE_TYPE.EXTRAS);
	// if both fries and dips are present under a composite product
	// they are merged into one "EXTRAS" step
	if(product.options.mergeDipsWithFries) {
		const dipsGroupIndex = productGroupsWithoutBaseProduct.findIndex(g => {
			return g.options && g.options.groupType === "dips";
		});
		const friesGroupIndex = productGroupsWithoutBaseProduct.findIndex(g => {
			return g.options && g.options.groupType === "fries";
		});
		if (dipsGroupIndex > -1 && friesGroupIndex > -1) {
			return stepsBasedOnRealGroups.filter((_, i) => i !== dipsGroupIndex);
		}
	}
	return stepsBasedOnRealGroups;
};
export const generateProductConfigSteps = (item) => {
	const product = item.product ? item.product : item;
	// we slice 1st group, since that is the main product
	// and on that position will potentially be the GROUPS_CONFIGS step
	const productGroupsWithoutBaseProduct = product.groups.slice(1).filter(group => {
		return group.options.showToCustomer !== false;
	});
	const stepsBasedOnRealGroups = getFilteredProductGroupSteps(productGroupsWithoutBaseProduct, product);
	return product.options.showGroupConfigs !== false
		? [CONFIGURATION_STATE_TYPE.GROUPS_CONFIGS, ...stepsBasedOnRealGroups]
		: stepsBasedOnRealGroups;
};
export const CONFIGURATION_STATE_TYPE = Object.freeze({
	SIZE: "SIZE",
	GROUPS_CONFIGS: "GROUPS_CONFIGS",
	DRINKS: "DRINKS",
	EXTRAS: "EXTRAS"
});

export const ORDER_STEPS = Object.freeze({
	1: "USER_DATA",
	2: "PICKUP_TIME",
	3: "PENDING_ORDER"
});

export const LOGIN_STEPS = Object.freeze({
	1: "LOGIN",
	2: "SIGNUP"
});

export const SUBCATEGORY_TYPES = Object.freeze({
	FAVOURITES: "FAVOURITES"
});

export const resetConfigurationStep = function(component) {
	component.$store.commit(mutationTypes.RESET_CONFIGURATION_STEP, { resetValue: 0 });
};

export const getFirstElementOfArray = function(array) {
	return array.find(x => x !== undefined);
};

export const globalTemplateName = appConfig.globalTemplateName;
export const channel = appConfig.channelAlias();
export const getCategoriesByTemplate = function({ productCatalog, onlyActive = true, sort = true }) {
	const categories = [...productCatalog.getCategories()].filter(cat => cat.isActive === onlyActive && cat.globalTemplate === appConfig.globalTemplateName);
	if (sort) {
		return categories.sort((p1, p2) => {
			return parseInt(p1.menuPosition) - parseInt(p2.menuPosition);
		});
	} else {
		return categories;
	}
};

/**
 *	Returns category object based on category ID
 *
 * @param {String} catId category ID
 * @param {ProductCatalog} productCatalog object
 * @returns {Category || undefined} promise that can successfully evaluate to appropriate category object
 */
export const getCategory = function(catId, productCatalog) {
	const categories = [...productCatalog.getCategories()]
		.filter(cat => cat.isActive === true && cat.globalTemplate === globalTemplateName)
		.sort((p1, p2) => parseInt(p1.menuPosition) - parseInt(p2.menuPosition));
	return categories.find(c => c.extId === parseInt(catId));
};
export const getCategoryById = function(catId, productCatalog) {
	const categories = [...productCatalog.getCategories()];
	return categories.find(c => c.extId === parseInt(catId));
};
export const getCategoriesByShopId = (shopId, productCatalog) => {
	const customerType = evaluateCustomerType();
	const categories = productCatalog.getCategories()
		.filter(cat => {
			const availableToCustomerType = !cat.customerTypes
				|| !cat.customerTypes.length
				|| cat.customerTypes.includes(customerType);
			if(cat.isSpecificForShops && cat.channels){
				if (Array.isArray(cat.isSpecificForShops)) {
					return cat.isSpecificForShops.includes(shopId)
						&& cat.isActive === true
						&& cat.channels.includes(channel)
						&& availableToCustomerType;
				}
				return cat.isActive === true
					&& cat.channels.includes(channel)
					&& availableToCustomerType;
			}
		})
		.sort((p1, p2) => parseInt(p1.menuPosition) - parseInt(p2.menuPosition));
	return [...categories];
};
export const findElementByType = (category, targetType) => {
	if (!category || !Array.isArray(category.elements)) {
		return { element: null, index: -1 };
	}

	const index = category.elements.findIndex(
		el => el.type === targetType && el.objType === "GridBlockElement"
	);

	const element = index !== -1 ? category.elements[index] : null;

	return { element, index };
};

/**
 * Checks if product can be picked up.
 *
 * @param product
 * @param productCatalog
 * @param pickupDateTimeRules
 * @param shopId
 * @returns {boolean}
 */
export const canBePickedUp = (product, productCatalog, pickupDateTimeRules, shopId) => {

	if (isProductDisabled(product) || isProductDisabledForDeliveryChoice(product) || !isProductAvailableForChannel(product)) {
		return false;
	}

	const boxDate = timeBox.realNow();
	const productSelections = [ProductSelection.createFromProduct(productCatalog.getProduct(product.id, true))];
	// TODO try using pure canBePickedUp!!

	return OrderHelperObject.canBePickedUp({
		boxDate,
		productSelections,
		tenantData: tenantConfig,
		pickupDateTimeRules: pickupDateTimeRules,
		shopId,
		productCatalog,
		hiddenItems: [store.getters.aBTestsHiddenItems, getHiddenItemsFromGiveawayCampaigns()].flat()
	});
};

/**
 * Filter the list of favorite products by globaly selected shopId
 *
 * @param favoriteProducts
 * @param productCatalog
 * @param globalSelectedShopId
 * @param cachedPickupRules
 * @returns
 */
export const filterCurrentUserFavoriteProductListByShopId = (
	favoriteProducts,
	productCatalog,
	globalSelectedShopId,
	cachedPickupRules
) => favoriteProducts.filter((favProd) => {
	try {
		const categoriesOfProduct = productCatalog.getAllCategoriesOfProduct(favProd.productId);
		const isProductCategoriesContainSelectedShop = categoriesOfProduct.some(
			(category) => Array.isArray(category.isSpecificForShops)
				&& category.isSpecificForShops.includes(globalSelectedShopId)
		);
		const isProductSupportedByActiveChannel = !categoriesOfProduct.length || categoriesOfProduct.filter(category => !category.channels || category.channels.includes(appConfig.channelAlias())).length;
		const product = productCatalog.getProduct(favProd.productId);
		return isProductCategoriesContainSelectedShop && isProductSupportedByActiveChannel && canBePickedUp(
			product,
			productCatalog,
			cachedPickupRules,
			globalSelectedShopId
		);
	} catch (e) {
		return undefined;
	}
});

export const evaluateCustomerType = () => {
	if(store.getters.isSubscribed) {
		return CUSTOMER_TYPES.PLUS_MEMBERS;
	}
	if(store.getters.isSunsetPointsMember) {
		return CUSTOMER_TYPES.POINT_MEMBERS;
	}
	return CUSTOMER_TYPES.GUESTS;
};

export const isProductDisabledForDeliveryChoice = (product) => {
	const deliveryChoice = store.getters.tenantSpecificData.deliveryChoice;
	return deliveryChoice !== undefined && product.options.deliveryMethodIndex ? !product.options.deliveryMethodIndex.includes(deliveryChoice) : false;
};

export const isProductAvailableForChannel = (product) => {
	const options = product.options;
	if (!options) {
		return true;
	}
	const channelToggles = options.channelTogglesState;
	return !(channelToggles && !channelToggles.includes(appConfig.channelAlias()));
};

export const isProductDisabled = (product) => {
	return product.id === undefined || product.isActive === false;
};

export const isProductAllowedToProceed = ({ product }) => {
	if (!product.isActive) {
		return false;
	}

	const deliveryChoice = store.getters.tenantSpecificData.deliveryChoice;
	return product.groups.every(group => group.products.some(product => {
		const options = product.options;
		if (!options) {
			return true;
		}
		if (options.deliveryMethodIndex) {
			if (!options.deliveryMethodIndex.includes(deliveryChoice)){
				return false;
			}
		}
		if (!isProductAvailableForChannel(product)) {
			return false;
		}
		return true;
	}));
};

export const removeUnavailableProducts = (group, productCatalog, pickupRules, shopId, deliveryOption) => {
	// TODO try using pure canBePickedUp!!
	const newProducts = group.products.filter(p => {
		const canProductBePickedUp = canBePickedUp(p, productCatalog, pickupRules, shopId);
		if (!canProductBePickedUp) {
			return canProductBePickedUp;
		}

		if(p.options && p.options.deliveryMethodIndex) {
			const isProductAllowed = p.options.deliveryMethodIndex.includes(deliveryOption);
			if(!isProductAllowed){
				return isProductAllowed;
			}
		}

		if (!isProductAvailableForChannel(p)) {
			return false;
		}

		const isNoThanks = isNoThanksProduct(p);
		if (!isNoThanks) {
			return !isNoThanks;
		}

		return appConfig.isBM100();
	});
	return remapDefaultSelectedProduct({...group, products: newProducts});
};

export const remapProductGroupDefaultSelectedProduct = (productGroups, deliveryOption) => {
	const newProductGroups = productGroups.map(group => {
		const newProducts = group.products.filter(p => {
			if(p.options && p.options.deliveryMethodIndex) {
				const isProductAllowed = p.options.deliveryMethodIndex.includes(deliveryOption);
				if(!isProductAllowed){
					return isProductAllowed;
				}
			}
			if (!isProductAvailableForChannel(p)) {
				return false;
			}
			return true;
		});
		if(newProducts){
			return remapDefaultSelectedProduct({...group, products: newProducts});
		}
	});

	const newProductGroupMap = {};
	newProductGroups.forEach(group => {
		newProductGroupMap[group.id] = group;
	});

	return {
		remappedGroups: newProductGroups,
		remappedGroupMap: newProductGroupMap
	};
};

export const remapDefaultSelectedProduct = (group) => {
	if(!group.options.defaultSelected) {
		return group;
	}

	const productsIds = group.products.map(product => {
		return product.id;
	});

	if(productsIds.includes(group.options.defaultSelected)) {
		return group;
	}

	/* it can happen that products are disabled by pickup rules
	 thus, we should check if group actually contains products
	 */
	const groupOptions = {
		...group.options,
		defaultSelected: group.products.length > 0
			? group.products[0].id
			: undefined
	};
	return {...group, options: groupOptions};
};

export const traverseArray = (array) => array
	.map((data) => {
		if (data instanceof Array) {
			return traverseArray(data);
		}

		if (typeof data === "object") {
			return traverseObject(data);
		}

		return data;
	})
	.flat();

export const traverseObject = (object) => Object
	.entries(object)
	.map(([objectKey, objectData]) => {
		if (objectData instanceof Array) {
			return { option: objectKey, value: traverseArray(objectData) };
		}
		if (typeof objectData === "object" && objectData) {
			return traverseObject(objectData);
		}
		return { option: objectKey, value: objectData };
	})
	.flat();

export const flowSetting = {
	set: (flowName) => sessionStorage.setItem("routesFlow", flowName),
	get: () => sessionStorage.getItem("routesFlow"),
	remove: () => sessionStorage.removeItem("routesFlow"),
	isFlow: (flowName) => sessionStorage.getItem("routesFlow") === flowName
};

export const getUserTimeZone = () => {
	return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
// this function returns keyword for name of subfolder based on screen width and channel
const getSortKeyword = (screenWidth, isKiosk, isUpgradeToMenuDialog = false) => {
	const imageSortKeywords = [
		{ min: 320, max: 671, keyword: "150" },
		{ min: 672, max: 1055, keyword: "365" },
		{ min: 1056, max: 1583, keyword: "349" },
		{ min: 1584, max: 1920, keyword: "400" },
		{ min: 1921, max: 3000, keyword: "600" }
	];
	if (isKiosk)  {
		if(isUpgradeToMenuDialog) {
			return "500";
		}
		return "353";
	}

	if (screenWidth < imageSortKeywords[0].min) {
		return imageSortKeywords[0].keyword;
	}

	if (screenWidth > imageSortKeywords[imageSortKeywords.length - 1].max) {
		return imageSortKeywords[imageSortKeywords.length - 1].keyword;
	}

	const match = imageSortKeywords.find(
		(range) => screenWidth >= range.min && screenWidth <= range.max
	);

	return match ? match.keyword : null;
};

const productImageCache = {};
export const getBackImages = (product, shouldBeKiosk = false, appendDoubleQuotes = false, isUpgradeToMenuDialog = false) => {
	const cacheKey = `${product.id}-${shouldBeKiosk}-${appendDoubleQuotes}`;
	const screenWidth = window.screen.width;
	const keyword = getSortKeyword(screenWidth, shouldBeKiosk, isUpgradeToMenuDialog);
	// if (!productImageCache[cacheKey]) {
	const defaultImageRatio = {
		[appConfig.businessModelsEnum.bm100.id]: "1T1",
		default: "8T5"
	};
	const lowerFolderValueRatio = Object.values(defaultImageRatio);
	const channel = appConfig.channelAlias();

	// @TODO check is this same as getImageFolder
	const splitFolderFromImage = (img) => {
		const imagePathSplit = img.split("/");
		if (imagePathSplit.length === 1) {
			const imageRatio = defaultImageRatio[tenantConfig.tenantId] || defaultImageRatio.default;
			return [channel === "kiosk" && shouldBeKiosk ? "kiosk" : imageRatio, img];
		}
		return imagePathSplit;
	};
	const extractKeyword = (img) => {
		const match = img.match(/\/(\d{3,})\//); // looks for 3 or more digits number between slashes in imageLink
		return match ? match[1] : null;
	};
	// check only once if webp is supported
	const webpSupported = appConfig.supportsWebP;
	productImageCache[cacheKey] = product.imageLinks
		.slice()
		.sort((img1, img2) => {
			const folderValues = [img1, img2]
				.map(splitFolderFromImage)
				.map(([directory]) => {
					return lowerFolderValueRatio.includes(directory) === shouldBeKiosk ? 1 : 0;
				});

			const folderComparison = folderValues[0] - folderValues[1];
			if (folderComparison !== 0) {
				return folderComparison;
			}

			// prioritize image that is inside corresponding folder depending on screen width
			const keyword1 = extractKeyword(img1);
			const keyword2 = extractKeyword(img2);
			const keywordComparison = (keyword2 === keyword ? 1 : 0) - (keyword1 === keyword ? 1 : 0);
			if (keywordComparison !== 0) return keywordComparison;

			// prioritize .webp format if supported
			if (webpSupported) {
				const isWebP1 = img1.endsWith(".webp") ? 1 : 0;
				const isWebP2 = img2.endsWith(".webp") ? 1 : 0;
				return isWebP2 - isWebP1;
			}

			return 0;
		})
		.map(img => {
			const lastFullStop = img.lastIndexOf(".");
			return img.substring(0, lastFullStop) + "_thumb" + img.substring(lastFullStop);
		})
		.map(imgURL => {
			const splitted = splitFolderFromImage(imgURL);
			if(splitted.length > 2) {
				return imageLoader(`${splitted[0]}/${splitted[1]}`, splitted[2], product, "dynamic", true, true);
			}
			return imageLoader(...splitted,  product, "dynamic", true, true);
		})
		.map((imgURL) => {
			return appendDoubleQuotes ? `"${imgURL}"` : imgURL;
		});
	// }

	return productImageCache[cacheKey];
};

export const transientReleaseToggles = {
	...appConfig.transientReleaseToggles
};

export const delay = (time, value = null, rejectDelay = false) => {
	return new Promise(function(resolve, reject) {
		const callback = rejectDelay === true ? reject : resolve;
		setTimeout(callback.bind(null, value), time);
	});
};

export const mapObject = (fromObject, toObject, props) => {
	props.forEach((prop) => {
		toObject[prop] = fromObject[prop] ? fromObject[prop] : toObject[prop];
	});
	return toObject;
};
export const getUrlParameter = (name, url) => {
	// if url is not specified, we use the current url as the default url
	if (url === undefined) {
		url = window.location.href;
	}
	name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
	const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
	const results = regex.exec(url);
	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export const deleteItemsFromLocalStorage = (items) => {
	items.forEach(item => {
		localStorage.removeItem(item);
	});
};

export const toLocaleDate = (date, locale) => {
	return timeBox.fromISO(date).setLocale(locale || appConfig.tenantConfig.locale).format("d. LLLL yyyy").exec();
};


export const toLocaleDateAndTime = (date, locale) => {
	return timeBox.fromISO(date).setLocale(locale || appConfig.tenantConfig.locale).format("d. LLLL yyyy 'at' H:mm").exec();
};

export const pickCategory = ( selectedShopId, catalog, getIconUrlFunction, router) => {

	let preselectedCategory = -1;
	let categories = getCategoriesByShopId(selectedShopId, catalog);
	const LOCAL_STORAGE_KEY = "scrollToProductIds";
	const preselectedProductIds = localStorage.getItem(LOCAL_STORAGE_KEY);
	if(preselectedProductIds) {
		const queryProductsIds = preselectedProductIds.split(",");
		const productId = queryProductsIds.find(productId => {
			return categories.find(category => {
				if(category.elements[0].props.products.includes(productId)){
					preselectedCategory = category;
					return category;
				}
			});
		});
		if(preselectedCategory !== -1){
			localStorage.removeItem(LOCAL_STORAGE_KEY);
			localStorage.setItem(LOCAL_STORAGE_KEY, productId);
			categories = categories.map(newCategory => {
				newCategory.isSelected = newCategory.id === preselectedCategory.id;
				newCategory.fullIconUrl = getIconUrlFunction(newCategory);
				return newCategory;
			});
			router.push(`/category/${preselectedCategory.extId}`);
		}
	}
	if (categories[0] && preselectedCategory === -1) {
		router.push({
			name: "defaultProductCatalog",
			params: {
				categoryId: categories[0].extId.toString()
			}
		});
	}
};
// if vat is included just do not supply vatRatesMgr
export const getSubscriptionPrice = async (subscriptionProvider, productPlanId, vatRatesMgr = undefined, productPlanChargeIdx = 0) => {
	const produtPlanDetails = await subscriptionProvider.getSubscriptionPlanById(productPlanId);
	const productPlanChargePrice = produtPlanDetails.productPlanCharges[productPlanChargeIdx].productPlanChargePricing[productPlanChargeIdx].price;
	if(vatRatesMgr){
		const vatRate = vatRatesMgr.getVatRate();
		const totalVat = vatRatesMgr.calculateTotalVat(productPlanChargePrice, vatRate.vatRate, false);
		return formatPriceZero(productPlanChargePrice+totalVat);
	}

	return formatPriceZero(productPlanChargePrice);
};

export const afterSuccessfulLoginHelper = async (featureToggles, store, showFromDifference = 1)=> {
	if(featureToggles.fraudProtection){
		const {activeSessions, maximumDevices} = await store.dispatch(mutationTypes.MAXIMUM_NUMBER_OF_DEVICES_REACHING);
		if(maximumDevices - Object.keys(activeSessions).length <= showFromDifference){
			store.commit(mutationTypes.SET_FRAUD_PROTECTION, {
				modalVisible: true,
				activeSessionsNumber: Object.keys(activeSessions).length,
				maximumDevicesNumber: maximumDevices,
				messageType: "maximumNumberOfDevicesReaching",
				activeSessions: activeSessions
			});
		}
	}
};

export const activeDevices = {
	getArray(activeSessions, reducer, t){
		return Object.keys(activeSessions).reduce((acc, curr) => {
			return reducer(activeSessions, acc, curr, t);
		}, [
		]);
	},
	formatForFraudProtectionDialog(activeSessions, acc, curr, t){
		const {device} = activeSessions[curr];
		if(!device) {
			LoggerProvider.logEvent({
				message: `Error: device is undefined: ${curr}: ${activeSessions[curr]}`,
				eventName: `Fraud protection device tracking unsuccessful`,
				eventCategory: "FraudProtection",
				eventDomain: "FraudProtectionDeviceTracking",
				data: {
					deviceData: {
						[curr]: activeSessions[curr]
					}
				}
			});
		}
		if(device && device !== "unknown"){
			const model = activeDevices.safeProp(device.model);
			const browser = activeDevices.safeProp(device.browser);
			const platform = activeDevices.safeProp(device.platform);
			const version = activeDevices.safeProp(device.version);
			const delimiter = ",";

			return [
				...acc,
				`${activeDevices.formatProp(model, browser)}${activeDevices.formatProp(browser, "")}${activeDevices.formatProp(delimiter, model || browser)}${activeDevices.formatProp(platform, version)}${activeDevices.formatProp(version, "")}`
			];
		}
		return [
			...acc,
			t("utilityComponents.fraudProtection.unknownDevice")
		];
	},
	// prop value could be "unknown" so we are formatting it to proper string
	safeProp(prop){
		return prop && prop !== "unknown" ? prop : "";
	},
	// if some props is missing trailing space shouldn't exist, for example when browser is missing
	// iPhone X , ... should be instead: iPhoneX, ...
	formatProp(prop, dependsOnProp){
		const res = dependsOnProp !== "" ? `${prop} ` : prop;
		return res;
	}
};

export const getSessionKey = (clientTraceId, deviceData) => {
	return deviceData && deviceData.uuid && deviceData.uuid !== "unknown" ? deviceData.uuid : clientTraceId;
};

export const getListTileText = (productCatalog, productSelection, group, objectName, selectedProductId) => {
	const staticRemapping = {
		default: {
		},
		[appConfig.businessModelsEnum.bm100.id]: {
			dip: "common.sideOrdersBm100"
		}
	};

	if (group.options.staticText) {
		const text = group.options.staticText;
		const remappingName = _.get(staticRemapping, `${tenantConfig.businessModelId}.${text.toLowerCase()}`);
		return remappingName || text;
	}
	if(selectedProductId){
		const prod = productCatalog.getProduct(selectedProductId);
		return {
			id: prod["id"],
			text: prod[objectName]
		};
	}
};
export const updateTenantSetting = async (settingName, settingValue) => {
	try{
		await store.dispatch("updateServerData", {
			settingName: settingName,
			settingValue: settingValue
		});
	} catch(e){
		return e;
	}
};
export const pushNotificationSubscription = ({topic, unsubscribe = false}) => {
	if (!appConfig.mobile.isMobileApp()) {
		return;
	}
	if (unsubscribe === true) {
		// eslint-disable-next-line no-console
		FCM.unsubscribeFrom({topic}).then(({message}) => console.log("[INFO] User", message));
	} else {
		// eslint-disable-next-line no-console
		FCM.subscribeTo({topic}).then(({message}) => console.log("[INFO] User", message));
	}
};

export const getActiveVersion = (globalVersions) => {
	if (!Array.isArray(globalVersions) || !globalVersions.length) {
		return 1;
	}

	const actvieVersionData = globalVersions.find(i => i.isActive === true);
	if (!actvieVersionData) {
		return 1;
	}

	return actvieVersionData.id;
};

export const subscribeToUniversalLinks = (router, cb) => {
	if (!appConfig.mobile.isMobileApp()) {
		return;
	}

	NativeApp.addListener("appUrlOpen", (event) => {
		if (!event.url) return;
		const url = new URL(event.url);
		const slug = url.pathname;
		const query = {};
		if(url.search) {
			const queryParams = new URLSearchParams(url.search);
			const keys = queryParams.keys();
			for (const key of keys) {
				query[key] = queryParams.get(key);
			}
		}
		cb && cb(event, slug);

		if (slug) {
			router.push({
				path: slug,
				query
			});
		}
	});
};

export const toBase64 = (blob) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(blob);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});

export const monthsDayMapper =  (month, year) => {
	switch (Number.parseInt(month)) {
	case 1:
		return 31;
	case 2:
		return Number.parseInt(year) % 4 === 0 ? 29 : 28;
	case 3:
		return 31;
	case 4:
		return 30;
	case 5:
		return 31;
	case 6:
		return 30;
	case 7:
		return 31;
	case 8:
		return 31;
	case 9:
		return 30;
	case 10:
		return 31;
	case 11:
		return 30;
	case 12:
		return 31;
	}
};

export const isDateBeforeToday = (year, month, day) => {
	const today = new Date();
	const pickedDate = new Date(year || 1, month - 1 || 0, day || 1);
	return today >= pickedDate;
};

export const isBirthdateValid = (day, month, year, isBirthdateOptional = false) => {
	const dayValid = day > 0 && day <= 31;
	const monthValid = month > 0 && month <= 12;
	const yearValid = year > 1900 && year <= (new Date()).getFullYear();
	const isBirthdayInputEmpty = !day && !month && !year;
	return (dayValid && monthValid && yearValid) || (isBirthdayInputEmpty && isBirthdateOptional);
};

export const getBaseDomain = (url) => {
	return url.replace(/(^\w+:|^)\/\//, "");
};

export const isDomainMatch = (domainsList, originDomain) => {
	const domains = domainsList.split(";");
	return domains.some(domain => domain.includes(getBaseDomain(originDomain)));
};

/**
 * Helper function to escape regular expression special characters
 */
export const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const addLogoToQRCode = (canvas, imagePath) => {
	if (canvas) {
		const context = canvas.getContext("2d");
		const baseImage = new Image();
		baseImage.src = imagePath;
		baseImage.onload = function () {
			const imageWidth = 50;
			const imageHeight = 50;
			const xOffset = (canvas.width - imageWidth) / 2;
			const yOffset = (canvas.height - imageHeight) / 2;
			context.drawImage(baseImage, xOffset, yOffset, imageWidth, imageHeight);
		};
	}
};

export const RCMSourceType = Object.freeze({
	CrossSell: "CrossSell",
	Carousel: "Carousel"
});

export const mapFeatureToggles = (featureToggles) => {
	const mappedFeatureToggles = {};
	Object.keys(featureToggles).forEach(key => {
		if (typeof featureToggles[key] === "object") {
			mappedFeatureToggles[key] = featureToggles[key].value;
		} else {
			mappedFeatureToggles[key] = featureToggles[key];
		}
	});
	return mappedFeatureToggles;
};

export const maskEmail = (email) => {
	if (!email) {
		return;
	}
	const parts = email.split("@");
	const firstLetter = parts[0][0];
	const restOfLetters = parts[0].slice(1);
	const masked = restOfLetters.replace(/./g, "*");

	return firstLetter + masked + "@" + parts[1];
};

export const LINK_PRODUCT_ACTIONS = Object.freeze({
	openProduct: "openProduct"
});

export const handlePreselectedProduct = (route) => {
	const productId = route.query.productId;
	const action = route.query.action;
	const LOCAL_STORAGE_KEY = "scrollToProductIds";
	const LOCAL_STORAGE_ACTION = "action";
	if (productId) {
		localStorage.setItem(LOCAL_STORAGE_KEY, productId);
		action ? localStorage.setItem(LOCAL_STORAGE_ACTION, action) : "";
	} else if (localStorage.getItem(LOCAL_STORAGE_KEY)) {
		localStorage.removeItem(LOCAL_STORAGE_KEY);
		localStorage.removeItem(LOCAL_STORAGE_ACTION);
	}
};

export function isMobileChannel() {
	const channel = localStorage.getItem("channel");
	return ["mobileApp", "mobileBrowser"].includes(channel);
}

export const getHiddenItemsFromGiveawayCampaigns = () => {
	if (store.getters.applicationUserLoggedIn && store.getters.isSunsetPointsMember) {
		const itemsThatReachedLimit = (store.getters.usedCampaigns || [])
			.filter(item => item.campaignId === "GiveawayCampaign" && item.usageCounter >= item.quantityPerUserLimit)
			.map(item => item.productId);
		const exceededPriceRules = getExceededPriceRules();
		const exceededPriceRulesFromGiveawayCampaign = exceededPriceRules.filter(r => r.label === "GiveawayCampaign");

		if (exceededPriceRulesFromGiveawayCampaign.length) {
			const hiddenItemsFromExceededPriceRules =	getProductIdsForPriceRuleId(exceededPriceRulesFromGiveawayCampaign.map(pr => pr.id));
			return [...itemsThatReachedLimit, ...hiddenItemsFromExceededPriceRules];
		}

		return itemsThatReachedLimit;
	}

	return [];
};

const groupByDetailsId = (data) => {
	return Object.values(
		data.reduce((acc, curr) => {
			if (curr.details.type !== "priceRule") {
				return acc;
			}

			const key = curr.details.id;

			if (!acc[key]) {
				acc[key] = {
					id: key,
					label: curr.details.label,
					type: curr.details.type,
					maxUsage: curr.details.maxUsage,
					totalUsageCount: 0
				};
			}

			acc[key].totalUsageCount += curr.details.usageCount || 0;

			return acc;
		}, {})
	).filter(item => item.totalUsageCount >= item.maxUsage);
};

export const getExceededPriceRules = () => {
	const limitedDiscountAssignments = store.getters.limitedDiscountAssignments;
	const priceRuleAssignments = limitedDiscountAssignments && limitedDiscountAssignments.filter(lda => lda.details.type === "priceRule");
	return priceRuleAssignments ? groupByDetailsId(priceRuleAssignments) : [];
};

export const getProductIdsForPriceRuleId = (priceRulesIds) => {
	const allPriceRules = store.getters.productCatalog.priceRules;
	const productIds = [];
	priceRulesIds.forEach(priceRuleId => {
		const matchingPriceRule = allPriceRules.find(pr => pr.id.toString() === priceRuleId);
		if(matchingPriceRule && matchingPriceRule.productPattern) {
			productIds.push(matchingPriceRule.productPattern);
		}
	});
	return productIds.flat();
};

export const calculateUnavailableSelections = async (payload) => {
	const { selections, globalSelectedShopId, cachedPickupRules, $store } = payload;

	const productCatalog = payload.productCatalog || $store.getters.getNonCachedProductCatalog();
	const deliveryChoice = payload.deliveryChoice || $store.getters.tenantSpecificData.deliveryChoice;

	const filteredProductSelections = filterCurrentUserFavoriteProductListByShopId(
		selections,
		productCatalog,
		globalSelectedShopId,
		cachedPickupRules
	);

	// Convert filtered product IDs to a Set for fast O(1) lookups
	// This allows us to quickly check if a product is available without iterating through arrays
	const filteredProductIds = new Set(filteredProductSelections.map(fp => fp.productId));

	// Build two data structures in a single pass through selections:
	// 1. unavailableSelections: Array of selections that aren't available at the new shop
	// 2. unavailableSelectionsMap: Map for fast lookup when checking if a root product is unavailable
	const unavailableSelections = [];
	const unavailableSelectionsMap = new Map();

	for (const selection of selections) {
		// If this product isn't available at the new shop, add it to unavailable lists
		if (!filteredProductIds.has(selection.productId)) {
			unavailableSelections.push(selection);
			unavailableSelectionsMap.set(selection.productId, selection);
		}
	}

	const unavailableSelectionIds = unavailableSelections.map(fp => fp.productId);
	const unavailableProducts = await ProductProvider.getProducts({productIds: unavailableSelectionIds});

	const newUnavailableSelections = unavailableSelections.map(selection => {
		const product = unavailableProducts.find(product => product.id === selection.productId);
		return {
			...selection,
			...(product && {
				name: product.name
			})
		};
	});

	// Process all selections to extract group product information
	// We're building a flat array of all group products from all selections
	// This flattens the nested structure: selections -> groups -> selectedProducts
	const groupProductSelections = selections.reduce((acc, selection) => {
		// Process each group within this selection
		if (selection.groups && selection.groups.length > 0) {
			const groupSelections = selection.groups.reduce((groupAcc, group) => {
				// Process each selected product within this group
				if (group.selectedProducts && group.selectedProducts.length > 0) {
					const productSelections = group.selectedProducts.reduce((productAcc, selectedProduct) => {
						// Extract the sub-product ID - it can be either a string or an object with productId
						const subProductId = typeof selectedProduct === "string"
							? selectedProduct
							: selectedProduct && selectedProduct.productId;

						// Only process if we have a valid sub-product ID
						if (subProductId) {
							productAcc.push({
								productId: subProductId,
								rootId: selection.productId,
								groupId: group.groupId,
								productSelectionId: selection.productSelectionId,
								appearance: group.appearance
							});
						}
						return productAcc;
					}, []);
					groupAcc.push(...productSelections);
				}
				return groupAcc;
			}, []);
			acc.push(...groupSelections);
		}
		return acc;
	}, []);

	// Process group products to find which ones are unavailable at the new shop
	if (groupProductSelections.length > 0) {
		const groupProductSelectionRootIds = groupProductSelections.map(selection => selection.rootId);
		const groupRootProducts = await ProductProvider.getProducts({productIds: groupProductSelectionRootIds});

		const newGroupProductSelections = groupProductSelections.map(selection => {
			const rootProduct = groupRootProducts.find(product => product.id === selection.rootId);
			return {
				...selection,
				...(rootProduct && {
					name: rootProduct.name
				})
			};
		});

		// Check each group product to see if it's available at the new shop
		// We use filter() to create an array of only the unavailable group products
		const unavailableGroupProductSelections = newGroupProductSelections.filter(selection => {
			try {
				const product = productCatalog.getProduct(selection.productId);
				if (product && product.options.deliveryMethodIndex && product.options.deliveryMethodIndex.length > 0) {
					return !product.options.deliveryMethodIndex.includes(deliveryChoice);
				}
				return !product;
			} catch (e) {
				return e.errorCode === "ProductIsUndefinedError";
			}
		});

		// Remove group selections where the root product is already marked as unavailable
		// This prevents duplicate removal operations and keeps the cart state clean
		// We use the Map for O(1) lookup instead of iterating through arrays
		const filteredUnavailableGroupProductSelections = unavailableGroupProductSelections.filter(groupSelection =>
			!unavailableSelectionsMap.has(groupSelection.rootId)
		);

		// Always set the filtered results, even if empty
		$store.commit(mutationTypes.SET_UNAVAILABLE_GROUP_SELECTIONS, filteredUnavailableGroupProductSelections);

		// Batch dispatch if there are unavailable selections
		if (unavailableGroupProductSelections.length > 0) {
			unavailableGroupProductSelections.forEach(selection => {
				$store.dispatch(mutationTypes.REMOVE_FROM_CART_SUB_PRODUCT, {
					productId: selection.productId,
					rootId: selection.rootId,
					productSelectionId: selection.productSelectionId
				});
			});
		}
	}

	// Batch commit and dispatch for unavailable selections
	if (newUnavailableSelections.length > 0) {
		$store.commit(mutationTypes.SET_UNAVAILABLE_SELECTIONS, newUnavailableSelections);
		newUnavailableSelections.forEach(selection => {
			$store.dispatch(mutationTypes.REMOVE_FROM_CART, selection.productId);
		});
	}
};
